module.exports = __webpack_public_path__ + "static/media/roundsBar.9d1793de.webp";